module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/theme/layouts/layout/layout.component.html
// module id = ../../../../../src/app/theme/layouts/layout/layout.component.html
// module chunks = main